const E2E_AUTH_KEY = "e2eAuthState";

type E2EAuthState = {
  uid: string;
  email: string;
  displayName: string;
  role: string;
};

export const isE2EMockAuthEnabled = (): boolean => {
  if (import.meta.env.VITE_E2E_MOCK_AUTH === "true") return true;

  if (typeof window !== "undefined") {
    try {
      if (localStorage.getItem("__e2eMockAuth") === "true") return true;
    } catch {
      // no-op
    }
  }

  return false;
};

export const getE2EAuthState = (): E2EAuthState | null => {
  if (!isE2EMockAuthEnabled()) return null;

  try {
    const raw = localStorage.getItem(E2E_AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as E2EAuthState;
  } catch {
    return null;
  }
};

export const setE2EAuthState = (state: E2EAuthState): void => {
  if (!isE2EMockAuthEnabled()) return;
  localStorage.setItem(E2E_AUTH_KEY, JSON.stringify(state));
  window.dispatchEvent(new Event("e2e-auth-changed"));
};

export const clearE2EAuthState = (): void => {
  if (!isE2EMockAuthEnabled()) return;
  localStorage.removeItem(E2E_AUTH_KEY);
  window.dispatchEvent(new Event("e2e-auth-changed"));
};
